<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-24 22:02:36
 * @LastEditTime: 2022-02-24 01:08:23
 * @LastEditors: chenguobiao
-->
<template>
  <div class="agreement page-normal">
    <common-header selected="user" />
    <div class="page-normal__content">
      <div class="agreement--box">
        <div class="agreement__header">国际象棋赛事考级购买协议</div>
        <div class="agreement__content">
          <div class="agreement__content__body" v-html="agreementContent"></div>
          <template v-if="countDownTimes === 0">
            <div class="agreement__content__button" @click="agree">
              <img src="@/render/assets/images/auth/agreement-button-bg.png">
              <div class="agreement__footer__button__text">我已阅读本协议</div>
            </div>
          </template>
          <template v-else>
            <div class="agreement__content__button">
              <img src="@/render/assets/images/auth/agreement-disabled-button-bg.png">
              <div class="agreement__footer__button__text">我已阅读本协议（{{ countDownTimes }}s）</div>
            </div>
          </template>
        </div>
        <common-back :backHome="false" />
      </div>
    </div>
  </div>
</template>

<script>
import { authAPI, personalAPI } from '@/apis'
import CommonHeader from '@/render/components/common/header'
import CommonBack from '@/render/components/common/back'
import { Timer, debounce } from '@/render/utils'
import { COUNTDOWN } from '@/config/const'
let timer = null
export default {
  components: {
    CommonHeader,
    CommonBack
  },
  data() {
    return {
      agreementContent: '',
      countDownTimes: 0,
      checkType: 0,
      productUid: '',
      uid: ''
    }
  },
  mounted() {
    this.getProtocol()
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(query) {
        let { checkType, productUid, uid } = query
        checkType = parseInt(checkType)
        if (productUid && [1, 2].includes(checkType)) {
          this.checkType = checkType
          this.productUid = productUid
          this.uid = uid
        } else {
          this.$router.replace('/home')
        }
      }
    }
  },
  destroyed() {
    timer && timer.stop()
  },
  methods: {
    async getProtocol() {
      const result = await authAPI.postGetProtocol({ uid: 2 })
      this.agreementContent = result.data.content
      this.startTimer(result?.data?.readTime ?? 15)
    },
    startTimer(_countDownTimes) {
      this.countDownTimes = _countDownTimes
      timer = new Timer(this.countDownTimes)
      timer.start(this.$bus, COUNTDOWN)
      this.$bus.on(COUNTDOWN, countDownTimes => {
        this.countDownTimes = countDownTimes
      })
    },
    agree: debounce(async function () {
      let { checkType, productUid, uid } = this
      let params = null
      let requestMethod = null
      if (checkType === 1) {
        requestMethod = personalAPI.postBuyProduct
        params = { uid: productUid }
      } else {
        requestMethod = personalAPI.postEnrollActivity
        params = { uid, productUid }
      }
      const { data } = await requestMethod(params)
      this.$router.push('/personal-payment?orderNum=' + data.orderNum)
    }),
  }
}
</script>

<style lang="scss">
.agreement {

  &--box {
    position: absolute;
    bottom: val(115);
    left: val(360);
    right: val(360);
    height: val(800);
    background: url('../../../assets/images/auth/agreement-bg.png') #fff no-repeat;
    background-size: 100%;
    border-radius: val(8);
    display: flex;
    flex-direction: column;

  }

  &__header {
    width: 100%;
    height: val(127);
    padding-top: val(66);
    font-size: val(24);
    font-weight: bold;
    color: #4E2500;
    text-align: center;
    line-height: val(24);
    box-sizing: border-box;
  }

  &__content {
    width: 100%;
    height: val(673);
    overflow: auto;
    padding: 0 val(77) val(64) val(77);

    &__body {
      font-size: val(14);
      line-height: val(30);
      color: #5E3C00;
    }

    &__button {
      position: relative;
      width: val(350);
      margin: 16px auto 0;

      &__text {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: val(24);
        color: #FFEFDB;
        cursor: pointer;
      }
    }
  }

  &__footer {
    padding-top: val(87);

    &__button {
      position: relative;
      width: val(350);
      margin: 0 auto;

      &__text {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: val(24);
        color: #FFEFDB;
        cursor: pointer;
      }
    }
  }
}
</style>
